<form class="m-t-24">
	<mat-card class="cardWithShadow">
		<mat-card-content class="p-5">
			<div class="row d-flex" >
				<div class="col-md-2" style="align-content: center;">
					<mat-label>Estado sistema</mat-label>
					<mat-slide-toggle [(ngModel)]="estadoSistema"
					style="display: inline-flex;"
					id="estadoSistema"
					name="estadoSistema"
					#tooltip="matTooltip"
					matTooltip= "{{estadoSistema ? 'Desactivar Sistema' : 'Activar Sistema'}}"
					matTooltipPosition="above"
					class="m-r-10 cursor-pointer"
					checked="{{estadoSistema}}">
					</mat-slide-toggle>
				</div>

				<div class="col-md-8 d-flex">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Mensaje</mat-label>
						<input type="text" autocomplete="off" 
						    matInput 
							id="mensajeSistema" 
							name="mensajeSistema" 
							[(ngModel)]="mensajeSistema"
							placeholder="Mensaje" />
						<mat-icon matPrefix class="op-5">mail</mat-icon>
					</mat-form-field>
				</div>
						
				<div class="col-md-2 d-flex">
					<button mat-flat-button (click)="guardarEstadoSistema()" color="primary" class="w-100">
						<mat-icon matPrefix class="op-5">save</mat-icon>
						Guardar
					</button>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</form>